module.exports = __webpack_public_path__ + "57af64fc644194101c1593abea164433.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto-v15-latin-500.woff
// module id = 1087
// module chunks = 0